import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgBin = function SvgBin(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    fill: "currentColor",
    viewBox: "0 0 24 24",
    size: size
  }, props), React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.452 7.5H4.547a.5.5 0 00-.5.545l1.287 14.136A2 2 0 007.326 24h9.347a2 2 0 001.992-1.819L19.95 8.045a.5.5 0 00-.498-.545zm-9.2 13a.75.75 0 01-1.5 0v-9a.75.75 0 011.5 0v9zm4.25.75a.75.75 0 00.75-.75v-9a.75.75 0 00-1.5 0v9c0 .414.336.75.75.75zM17.25 4H22a1 1 0 110 2H2a1 1 0 010-2h4.75A.25.25 0 007 3.75V2.5A2.5 2.5 0 019.5 0h5A2.5 2.5 0 0117 2.5v1.25c0 .138.112.25.25.25zM9 2.5v1.25c0 .138.112.25.25.25h5.5a.25.25 0 00.25-.25V2.5a.5.5 0 00-.5-.5h-5a.5.5 0 00-.5.5z",
    clipRule: "evenodd"
  }));
};

export default SvgBin;